import ProductCard from './ProductCard';
import useRevealOnScroll from '../../hooks/useRevealOnScroll';

import css from './ProductGrid.module.css';

const ProductGridItem = ({ listing }) => {
  const { ref, isVisible } = useRevealOnScroll();
  const classes = isVisible ? `${css.revealCard} ${css.revealCardVisible}` : css.revealCard;

  return (
    <div className={classes} ref={ref}>
      <ProductCard listing={listing} />
    </div>
  );
};

const ProductGrid = ({ productGridRef, searchInProgress, listings }) => {
  return (
    <div className={css.container} ref={productGridRef}>
      {searchInProgress && listings.length === 0 ? (
        <div className={css.productLoading}>Loading resale listings…</div>
      ) : null}

      <div className={css.grid}>
        {listings.length > 0
          ? listings.map((listing, index) => (
              <ProductGridItem key={`${listing.id}-${index}`} listing={listing} />
            ))
          : !searchInProgress && (
              <div className={css.productEmptyState}>
                We couldn't find items for this filter yet. Try another category while we expand the
                collection.
              </div>
            )}
      </div>
    </div>
  );
};

export default ProductGrid;
